export default __webpack_public_path__ + "static/media/joinNewsletter-1.94f5abb6.png";